/**
 * Bundle-splitter status-poll states after which a task never changes again
 * (the poll also reports in-progress states such as PROGRESS and RETRY).
 */
export const TASK_ENDED_STATES: ReadonlySet<string> = new Set([
  "SUCCESS",
  "FAILURE",
  "REVOKED",
]);
